<template>
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <h5>Performing action...</h5>
      </div>
    </div>
  </div>
</template>

<script>
import { layoutMethods, peddlrWalletMethods } from "@/state/helpers";
import Swal from "sweetalert2";

export default {
  props: ["token", "action", "s3_url"],
  methods: {
    ...peddlrWalletMethods,
    ...layoutMethods,
    goToList(){
      this.$router.push({ name:"Adjustment Transaction Dashboard" });
    }
  },
  mounted() {
    this.changeTitle({title: 'Adjustment Transaction Bulk Action'});
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "kankolek", to: { name: "" } },
        { text: "Adjustment Transaction", to: { name: "" } },
        { text: "Action", to: { name: "" } },
      ],
    });

    this.invokeBulkProcessFunction({
      task: "bulk-adjustment-action",
      body: {
        token: this.token,
        action: this.action,
        s3_url: `adjusment-transactions/${this.s3_url}.csv`
      }
    })
      .then(() => {
        Swal.fire({
          title: "Action Successful!",
          text: `Adjustment Transaction has been ${this.action == 'approve' ? 'approved' : 'denied' } successfully.`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#c4297c",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.value) {
            this.goToList();
          }
        });
      })
      .catch((error) => {
        Swal.fire({
          title: "Action Failed!",
          html: `Adjustment Transaction has not been ${this.action == 'approve' ? 'approved' : 'denied' }.<br />${error}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "#c4297c",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.value) {
            this.goToList();
          }
        });
      });
  }
};
</script>

<style>
</style>